<template>
    <div style="background: #f4f4f4; padding-bottom: 40px">
        <div class="container" v-if="goodsStatus==='PASS'">
            <div class="flex" style="
          align-items: center;
          padding: 20px 0;
          color: #808080;
          font-size: 14px;
        ">
                <span>当前位置：</span>
                <el-breadcrumb separator=">">
                    <el-breadcrumb-item :to="{ path: '/print' }">我要打印</el-breadcrumb-item>
                    <el-breadcrumb-item>服务详情</el-breadcrumb-item>
                </el-breadcrumb>
                <!-- <span>增材云</span>
                 <span>></span>
                 <span>我要打印</span>
                 <span>></span>
                 <span>服务详情</span> -->
            </div>
            <section>
                <el-row :gutter="30" class="containerStyleClass">
                    <el-col :span="18" style="padding: 0">
                        <div class="containerLeftTop">
                            <div class="softwareLogo">
                                <div class="block">
                                    <el-carousel height="200px">
                                        <el-carousel-item v-for="(item,index) in carouselList" :key="index"
                                                          direction="false">
                                            <img :src="item.urlPath" alt="" style="width: 100%;height: 200px;">
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </div>

                            <div class="softwareRight">
                                <div class="topServBoxInfo">
                                    <h3>{{ serviceabilityInfo.serviceName }}</h3>
                                    <div class="collect">
                                        <i v-if="collect" class="el-icon-star-on"
                                           style="margin-right: 8px;color: #E6A23C;cursor: pointer;font-size: 24px;"
                                           @click="removeCollect"></i>
                                        <i v-if="!collect" class="el-icon-star-off"
                                           style="margin-right: 8px;cursor: pointer;font-size: 22px;"
                                           @click="saveCollect"></i>
                                        <span style="font-size: 16px;"> {{ serviceabilityInfo.collectionVolume }} </span>
                                    </div>
                                </div>
                                <div class="flex topServBoxMess">
                                    <div class="flex">
                                        <p class="topServBoxMesscolor">服务价格：</p>
                                        <span class="red">¥{{ serviceabilityInfo.servicePrice }}元</span>
                                    </div>
                                    <div class="topServBoxMesscolor2">议价</div>
                                </div>
                                <div class="flex topServBoxMess">
                                    <div class="flex">
                                        <p class="topServBoxMesscolor">服务行业：</p>
                                        <p class="topServBoxMesscolor2">{{ serviceabilityInfo.serviceTradeName }}</p>
                                    </div>
                                </div>
                                <div class="flex topServBoxMess">
                                    <div class="flex">
                                        <p class="topServBoxMesscolor">材料类型：</p>
                                        <p class="topServBoxMesscolor2">{{ serviceabilityInfo.serviceMaterialName }}</p>
                                    </div>
                                </div>
                                <div class="flex topServBoxMess">
                                    <div class="flex">
                                        <p class="topServBoxMesscolor">项目地址：</p>
                                        <p class="topServBoxMesscolor2">
                                            <i class="el-icon-location"></i>
                                            {{ serviceabilityInfo.province }} {{ serviceabilityInfo.city }} {{
                                            serviceabilityInfo.district }}
                                        </p>
                                    </div>
                                </div>
                                <div class="businessVolume">
                                    <div class="businessVolumeLeft">近180天成交量：{{ completeCount }}笔</div>
                                    <div class="businessVolumeRight">
                                        <span>用户评分：</span>
                                       <div v-if="Number(evaluationNumber) === 0">暂无</div>
										<el-rate
												v-else
                                                :value="evaluationNumber"
                                                disabled
                                                :colors="['#da251d', '#da251d', '#da251d']"
                                        >
                                        </el-rate>
                                    </div>
                                </div>
                                <div>
                                    <el-button
                                            type="primary"
                                            style="background: #177efc; border-radius: 10px" @click="createOrder"
                                    >立即下单
                                    </el-button
                                    >
                                    <el-button type="" style="color: #409eff; border-radius: 10px"
                                               @click="startChat(serviceabilityInfo.userUuid)"
                                    >联系商家
                                    </el-button
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="containerLeftBottom">
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane
                                        label="服务详情"
                                        name="first"
                                        class="bottomMessage">
                                    <div v-html="serviceabilityInfo.serviceContent" class="vHtmlMess"></div>
                                </el-tab-pane>
                                <el-tab-pane label="评价详情" name="second">
                                    <div class="evaluationDetails" v-if="conmmentList.length != 0" v-loading="loading">
                                        <div class="flex right_sortbox">
                                            <p
                                                    :class="sortboxIndex == index ? 'p_active' : ''"
                                                    v-for="(items, index) in sortBox"
                                                    :key="index"
                                                    @click="getSortBox(index)">
                                                {{ items.name }} ({{ items.num }})
                                            </p>
                                        </div>
                                        <div v-for="(items, index) in conmmentList"
                                             :key="index">
                                            <div class="comList flex">
                                                <div class="comList_img">
                                                    <img :src=items.image alt=""/>
                                                </div>
                                                <div class="comList_con">
                                                    <p class="con_title">{{items.title}}</p>
                                                    <p class="con_mess">
                                                        {{items.messages}}
                                                    </p>
                                                    <span> {{items.time}}</span>
                                                </div>
                                                <div class="comList_star">
                                                    <div class="comList_star_A flex">
                                                        <span>描述相符</span>
                                                        <el-rate v-model="items.designerStar" disabled
                                                                 :colors="colors"></el-rate>
                                                    </div>
                                                    <div class="comList_star_A flex">
                                                        <span>服务态度</span>
                                                        <el-rate v-model="items.designerStar2" disabled
                                                                 :colors="colors"></el-rate>
                                                    </div>
                                                    <div class="comList_star_A flex">
                                                        <span>专业程度</span>
                                                        <el-rate v-model="items.designerStar3" disabled
                                                                 :colors="colors"></el-rate>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 回复 -->
                                            <div v-if="items.reply" class="additional_evaluation">
                                                设计师回复：{{items.reply}}
                                            </div>
                                        </div>
                                        <div style="text-align: right; padding: 0 0px 30px">
                                            <el-pagination
                                                    background
                                                    @current-change="handleCurrentChange"
                                                    @prev-click="handleCurrentChange"
                                                    @next-click="handleCurrentChange"
                                                    layout="total,prev, pager, next,jumper"
                                                    :current-page="current"
                                                    :page-size="pageSize"
                                                    :total="total" class="pagination">
                                            </el-pagination>
                                        </div>
                                    </div>
                                    <div v-else class="modelDeta_centerMess" v-loading="loading">
                                        <!-- 暂无评价信息 -->
										<img src="../../assets/暂无内容.jpg" style="width: 200px;">
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane
                                        label="成交记录"
                                        name="third"
                                        class="bottomMessage">
                                    <div>
                                        <TransactionRecords ref="transactionRecordRef"></TransactionRecords>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="relatedRecommendation" style="height:337px">
                            <div class="recommendationTop">
                                <img v-if="storeLogo!=null
                                            && storeLogo!=undefined
                                            && storeLogo!=''" :src="storeLogo" alt=""/>
                                <img v-else src="@/assets/image/服务商_画板 1.jpg"/>
                            </div>
                            <div class="recommendationTopMess">
                                <h4 class="recommendationTopH4">{{ serviceabilityInfo.enterPriseName }}</h4>
                                <p>
                                    <i></i>
                                    在售服务：
                                    <span class="red">{{ serviceabilityInfo.serviceSellerCount }}</span>
                                    个
                                </p>
                                <p>
                                    <i></i>
                                    累计销售：
                                    <span class="red">{{ sellerCount }}</span>
                                    笔
                                </p>
                                <p>
                                    <i></i>
                                    综合好评： {{ evaluationNumber/5*100 }}%
                                </p>
                                <el-button type="primary" plain style="margin-top: 10px"
                                           @click="gotoProvidersSettled(serviceabilityInfo.enterPriseId)"
                                >进店看看
                                </el-button
                                >
                            </div>
                        </div>
                        <div class="relatedRecommendation" style="margin-top: 10px">
                            <div class="printTitle flex">
                                最新服务
                                <p @click="changeServiceInfo" style="cursor: pointer;">换一批 <i
                                        class="el-icon-refresh"></i></p>
                            </div>
                            <div class="hotRecommendation"
                                 v-if="info.length>0"
                                 v-for="(item,index) in info"
                                 :key="index"
                                 @click="getServiceDetails(item.uuid)">
                                <div class="flex newRightBox">
                                    <div class="newRightBoximg">
                                        <img :src="item.urlList[0].urlPath" alt=""
                                             v-if="item.urlList!=null && item.urlList.length > 0"/>
                                    </div>
                                    <div class="newRightBoxMess">
                                        <div class="h4">
                                            <h4>{{ item.serviceName }}</h4>
                                            <div>{{ item.serviceName }}</div>
                                        </div>
                                        <p>{{ item.enterPriseName }}</p>
                                        <p>
                                            <i class="el-icon-location"></i>
                                            {{ item.province }} {{ item.city }}
                                        </p>
                                    </div>
                                </div>
                                <div class="flex newRight">
                                    <p class="newRightColor">服务价格：</p>
                                    <span class="red">¥{{ item.servicePrice }}元</span>
                                    <div class="newRightColor2">议价</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </section>
        </div>
        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
        <!-- 下架显示 -->
        <div class="shelves" v-if="goodsStatus!=='PASS'">
            <img src="../../assets/storeDown.png" alt="" />
            <p class="shelves_name">该服务已下架</p>
            <p class="shelves_time">
                <span>{{ second }}</span>
                <span>秒后返回服务列表</span>
            </p>
            <p class="shelves_click" @click="goToServiceList">点击跳转服务列表</p>
        </div>
    </div>
</template>

<script>
    // 成交记录
    import TransactionRecords from '../transactionRecords/transactionRecords'
    import {
        getServiceabilityDetail, getNewcurrent, getEvaluationNumber,
        isCollection, saveServiceCollection, removeCollection, getServiceOrderCompleteCount,
        getNewServiceability, addServiceOrder, saveVisitorLog, getEvaluationList, getUserInfo, getTagsByGoodsId,
    } from '../../utils/interface';
    import chatDialog from '../chat/chatDialog'
    import {mapState, mapMutations} from "vuex";

    export default {
        //   软件超市详情页
        name: "saasDetails",
        metaInfo () {
            return {
                title: this.metaTitle,
                meta: [{                 // set meta
                    name: "keywords",
                    content: this.metaKeywords,
                },
                    {                 // set meta
                        name: "description",
                        content: this.metaDescription,
                    }
                ],
            }
        },
        components: {chatDialog, TransactionRecords},
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
                isLogin: "isLogin",
                isUsermessage: "isUsermessage"
            }),
        },
        data() {
            return {
                activeName: "first",
                url: require("../../assets/软件超市/精品/铸造执行系统MES.png"),
                carouselList: [],
                searchInputValue: "",
                typeCheckValue: "one",
                buyNum: "1",
                uuid: '',
                serviceabilityInfo: '',
                info: '',
                collect: false,
                sortBox: [],
                sortboxIndex: "0",
                colors: ["#da251d", "#da251d", "#da251d"],
                loading: true,
                conmmentList: [],
                userMessages: {},
                collectUuid: "",
                current: 1,
                total: 0,
                pageSize: 5,
                form: {},
                completeCount: 0,
                gradeCount: 0,
                evaluationNumber: 0,
                sellerCount: 0,
                second:5,
                timeout:"",
                goodsStatus:"PASS",
                metaTitle:'',
                metaKeywords:'',
                metaDescription:'',
                storeLogo:"",
            };
        },
        created() {
            this.uuid = this.$route.params.uuid;
            // 查询详情信息
            this.getServiceabilityDetail();
            // 随机查询
            this.changeServiceInfo();
            // 获取用户信息
            getNewcurrent().then((res) => {
                this.userMessages = res;
            })
            .catch((err) => {
                console.log(err);
            });
            this.commentList();
            // 倒计时
            this.timeout = setInterval(()=>{
                this.second--;
                if(this.second===0){
                    clearInterval(this.timeout);
                    if(this.goodsStatus!=='PASS'){
                        this.goToServiceList();
                    }
                }
            },1000);
        },
        methods: {
            goToServiceList(){
                let routeData = this.$router.resolve({
                    name: "printList",
                });
                window.open(routeData.href, "_self");
            },
            ...mapMutations(["isLoginVuex"]),
            gotoProvidersSettled(enterPriseId) {
                let routeData = this.$router.resolve({
                    name: "printServiceIndex",
                    params: {enterPriseId: enterPriseId},
                });
                window.open(routeData.href, "_blank");
            },
            handleClick(tab, event) {
                console.log(tab, event);
                if (tab.index == 1) {
                    this.commentList();
                }
                if (tab.index == 2) {
                    this.$refs.transactionRecordRef.init("", "SERVICE", "", this.uuid, "");
                }
            },
            getServiceabilityDetail() {
                let params = {
                    uuid: this.uuid
                };
                getServiceabilityDetail(params).then((res) => {
                    this.goodsStatus = res.data.examineStatus;
                    /*if(res.data.examineStatus!=='PASS'){
                        this.$confirm('该服务已下架！', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            let routeData = this.$router.resolve({
                                name: "printList"
                            });
                            window.open(routeData.href, "_self");
                        }).catch(() => {
                            let routeData = this.$router.resolve({
                                name: "printList"
                            });
                            window.open(routeData.href, "_self");
                        });
                        return false;
                    }*/
                    this.serviceabilityInfo = res.data;
                    this.storeLogo = this.serviceabilityInfo.storeLogo;
                    this.metaTitle = res.data.serviceName+" - 我要打印-增材云";
                    this.metaKeywords = res.data.metaKeywords;
                    this.metaDescription = res.data.metaDescription;

                    this.carouselList = res.data.urlList;
                    //足迹
                    this.saveVisitorLog();
                    // 查询用户是否保存当前服务
                    this.isCollectInfo();
                    // 查询成交量
                    this.getServiceOrderCompleteCount();
                    // 查询评分
                    this.getEvaluationNumber();
                });
            },
            getServiceOrderCompleteCount() {
                getServiceOrderCompleteCount({serviceUuid: this.serviceabilityInfo.uuid}).then((res) => {
                    if (res.success) {
                        this.completeCount = res.data;
                    }
                });
            },
            getEvaluationNumber() {
                getEvaluationNumber({
                    serviceUuid: this.serviceabilityInfo.uuid,
                    userUuid: this.serviceabilityInfo.userUuid
                }).then((res) => {
                    if (res.success) {
                        this.evaluationNumber = res.data.evaluationNumber;
                        this.sellerCount = res.data.sellerCount;
                    }
                });
            },
            isCollectInfo() {
                let params = {
                    serviceabilityUuid: this.serviceabilityInfo.uuid
                };
                isCollection(params).then((res) => {
                    if (res && res.data != null) {
                        this.collect = true;
                        this.collectUuid = res.data.uuid;
                    } else {
                        this.collect = false;
                    }
                });
            },
            changeServiceInfo() {
                getNewServiceability().then((res) => {
                    this.info = res;
                });
            },
            getServiceDetails(uuid) {
                let routeData = this.$router.resolve({
                    name: "printServiceDetails",
                    params: {uuid: uuid},
                });
                window.open(routeData.href, "_blank");
            },
            createOrder() {
                if (this.isLogin) {
                    if (this.serviceabilityInfo.userUuid == this.userMessages.uuid) {
                        this.$message.error('无法询价自己的服务');
                        return false;
                    }/*else if(this.userMessages.identity==="ANONYMOUS"){
                        this.$confirm('请先进行实名认证!', '提示', {
                            confirmButtonText: '去认证',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push('/userCenter/10');
                            /!*window.sessionStorage.setItem("userServeId", "10");
                            let routeData = this.$router.resolve({
                                name: "userCenter",
                            });
                            window.open(routeData.href, "_target");*!/
                        });
                        return false;
                    }*/
                    addServiceOrder({
                        serviceUuid: this.serviceabilityInfo.uuid,
                        num: 1,
                        serviceName:this.serviceabilityInfo.serviceName,
                        totalPrice: this.serviceabilityInfo.servicePrice,
                        servicePrice: this.serviceabilityInfo.servicePrice,
                        serviceStatus: "UN_CONFIRM",
                        orderBase: {
                            orderStatus: "UN_CONFIRM",
                        },
                    }).then((res) => {
                        if (res.success) {
                            this.$router.push({name: 'printSendSuccess', params: {orderCode: res.data.orderNo}});
                        }
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            getSortBox(index) {
                this.sortboxIndex = index;
                this.handleCurrentChange(1);
            },
            saveCollect() {
                // 如果为当前登录用户的服务则不允许收藏
                // 获取当前用户信息
                if (this.isLogin) {
                    if (this.serviceabilityInfo.userUuid == this.userMessages.uuid) {
                        this.$message.error('无法收藏自己的服务');
                        return false;
                    }
                    // 收藏服务
                    let params = {
                        serviceabilityUuid: this.serviceabilityInfo.uuid,
                        type: 0
                    };
                    saveServiceCollection(params).then((res) => {
                        if (res.success) {
                            this.$message.success('收藏成功!');
                            this.collectUuid = res.data.uuid;
                            this.serviceabilityInfo.collectionVolume++;
                            this.isCollectInfo();
                        }
                    });
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
            removeCollect() {
                // 收藏服务
                let params = {
                    uuid: this.collectUuid
                };
                removeCollection(params).then((res) => {
                    if (res.success) {
                        this.$message.success('取消成功!');
                        this.collectUuid = "";
                        this.serviceabilityInfo.collectionVolume--;
                        this.isCollectInfo();
                    }
                });
            },
            saveVisitorLog() {
                let param = {
                    title: this.serviceabilityInfo.serviceName,
                    logo: this.carouselList[0].urlPath,
                    visitorType: 'SERVICE',
                    price: this.serviceabilityInfo.servicePrice,
                    link: window.location.href
                };
                /*if(this.carouselList !==undefined && this.carouselList.length > 0){
                    param = JSON.parse(param).map(item => {
                        return {...item, price: this.carouselList.urlPath}
                    })
                }*/
                saveVisitorLog(param);
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val
				window.scrollTo(0,0);
                this.commentList();
            },
            commentList() {
                if (this.sortBox.length > 1) {
                    this.form.tags = this.sortBox[this.sortboxIndex].id;
                }
                this.loading = true
                this.form.uuid = this.uuid;
                this.form.orderType = 'SERVICE';
                this.form.evaluationType = 'NORMAL';
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                getEvaluationList(this.form).then((res) => {
                    console.log(res);
                    if (res != null && res.list != null && res.list.length > 0) {
                        this.total = res.total;
                        this.conmmentList = [];
                        if (this.sortBox.length == 0) {
                            this.sortBox.push({
                                name: '全部',
                                num: res.total
                            });
                        }
                        if (this.sortBox.length == 1) {
                            getTagsByGoodsId(this.form).then((res) => {
                                if (res != null && res.length > 0) {
                                    res.forEach((items, index) => {
                                        this.sortBox.push({
                                            id: items.tagUuid,
                                            name: items.tagName,
                                            num: items.evaluationNum,
                                        });
                                    });
                                }
                            });
                        }
                        res.list.forEach((item, index) => {
                            let evaluation = {};
                            evaluation.order = item;
                            evaluation.uuid = item.uuid;
                            evaluation.title = item.creator;
                            evaluation.messages = item.evaluationContent;
                            evaluation.designerStar = parseInt(item.descriptionPoint);
                            evaluation.designerStar2 = parseInt(item.servicePoint);
                            evaluation.designerStar3 = parseInt(item.transportPoint);
                            evaluation.time = item.createTime
                            evaluation.image = (item.iconUrl ? item.iconUrl : require('../../assets/设计市场/头像1.jpeg'));

                            if (item.addedReplys != null && item.addedReplys.length > 0) {
                                item.addedReplys.some((item, index) => {
                                    if (item.evaluationType == 'REPLY') {
                                        evaluation.reply = item.evaluationContent;
                                        return true;
                                    }
                                });
                            }
                            this.conmmentList.push(evaluation);
                            this.loading = false
                            console.log(this.conmmentList);
                        });
                    } else {
                        this.total = 0;
                        this.loading = false
                    }
                });
            },
            startChat(targetUserId) {
                if (this.isLogin) {
                    let user = this.$store.state.isUsermessage;
                    if (this.serviceabilityInfo.userUuid == this.userMessages.uuid) {
                        this.$message.error('检测服务所属企业与您处于同一企业，暂不支持联系!');
                        return false;
                    } else {
                        getUserInfo(targetUserId).then(res => {
                            console.log('targetUserId-------' + targetUserId);
                            console.log(res);
                            this.$refs.chatDialogRef.init(user.uuid, user.name, user.headUrl, res.uuid, res.name, res.headUrl);
                        });
                    }
                } else {
                    this.$message({
                        type: "success",
                        message: "您需要先登录哦！",
                    });
                    this.$router.push('/login')
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .red {
        color: #da251d;
    }

    .containerTop {
        background: #fff;
        margin-bottom: 10px;

        .searchPart {
            width: 100%;
            padding: 18px 0 5px;
            display: flex;

            .searchPartRight {
                width: 690px;
                padding: 0 15px;
                margin: 0 0 0 156px;

                /deep/ .el-input__inner {
                    border: 1px solid #157efb;
                    border-radius: 10px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    background: #fdfdfd;
                }

                /deep/ .el-input-group__append {
                    background-color: #157efb;
                    color: #fff;
                    border: 1px solid #157efb;
                    width: 80px;
                    box-sizing: border-box;
                    text-align: center;
                    border-radius: 0px 10px 10px 0px;
                }

                ul {
                    display: flex;
                    font-size: 12px;
                    color: #2c2f37;
                    padding: 3px 0 3px 16px;

                    li.topSearchTitle {
                        padding: 4px 20px 4px 0;
                        color: #c0c0c0;

                        &:hover {
                            cursor: pointer;
                            color: #157efb;
                        }
                    }

                    li.line {
                        padding: 2px 0;
                        font-size: 14px;
                    }
                }
            }
        }

        .classify {
            width: 235px;
            color: #fff;
            background: #157efb;
            height: 35px;
            line-height: 35px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;
            margin-top: 10px;

            span {
                font-weight: 700;
                font-size: 14px;
                padding-left: 5px;
            }
        }
    }

    .container {
        width: 1200px;
        margin: 0 auto;

        .containerStyleClass {
            box-sizing: border-box;
            margin: 0 !important;

            .containerLeftTop {
                background: #fff;
                padding: 30px;
                box-sizing: border-box;
                display: flex;
                height: 337px;

                .softwareLogo {
                    width: 275.5px;
                    height: 200px;
                    margin-right: 30px;

                    .block {
                        width: 275.5px;
                        height: 200px;
                    }

                    .el-carousel__item h3 {
                        color: #475669;
                        font-size: 14px;
                        opacity: 0.75;
                        line-height: 150px;
                        margin: 0;
                    }

                    .el-carousel__item:nth-child(2n) {
                        background-color: #99a9bf;
                    }

                    .el-carousel__item:nth-child(2n + 1) {
                        background-color: #d3dce6;
                    }
                }

                .softwareRight {
                    width: 720px;

                    .topServBoxInfo {
                        position: relative;

                        h3 {
                            width: 450px;
                            font-family: "Roboto Slab", Helvetica, Arial, sans-serif;
                            font-weight: 500;
                            font-size: 18px;
                            margin-bottom: 14px;
                            color: #2c2f37;
                        }

                        p {
                            font-size: 12px;
                            color: #2c2f37;
                            line-height: 20px;
                        }

                        .collect {
                            position: absolute;
                            right: 25px;
                            top: 0;
                            font-size: 12px;
                            color: #333;

                            i {
                                font-size: 18px;
                                vertical-align: bottom;
                                padding-left: 5px;
                                cursor: pointer;

                                &.el-icon-star-on {
                                    color: #fcb830;
                                }
                            }
                        }
                    }

                    .businessVolume {
                        background-color: rgba(229, 125, 32, 0.1);
                        margin: 10px 0 20px;
                        display: flex;

                        .businessVolumeLeft {
                            padding: 15px;
                            width: 50%;
                            box-sizing: border-box;
                            font-weight: 500;
                            color: rgba(0, 0, 0, 0.7);
                            font-size: 14px;
                        }

                        .businessVolumeRight {
                            padding: 15px;
                            width: 50%;
                            box-sizing: border-box;
                            display: flex;
                            border-left: 1px solid #ccc;
                            color: #999;
                            font-size: 14px;
                        }
                    }

                    .topServBoxMess {
                        justify-content: space-between;
                        margin-bottom: 14px;
                        font-size: 13px;

                        .topServBoxMesscolor {
                            color: #999;
                        }

                        .topServBoxMesscolor2 {
                            color: #333;
                            margin-right: 40px;
                        }
                    }

                    .buySoftwareForm {
                        /deep/ .el-form-item__label {
                            padding: 0 10px 0 0;
                            color: #2c2f37;
                            font-size: 13px;
                        }

                        /deep/ .el-radio-button__inner {
                            margin: 0 10px 10px 0;
                            border: 1px solid #eee;
                            border-radius: 0;

                            &:hover {
                                color: #2c2f37;
                                background-color: #eee;
                            }
                        }

                        /deep/
                        .el-radio-button__orig-radio:checked
                        + .el-radio-button__inner {
                            color: #fff;
                            background-color: #157efb;
                            border-color: #157efb;
                            -webkit-box-shadow: -1px 0 0 0 #157efb;
                            box-shadow: -1px 0 0 0 #157efb;
                        }

                        /deep/ .el-form-item {
                            margin-bottom: 15px !important;
                        }

                        .buySoftwareFormSubmit {
                            /deep/ .el-form-item__content {
                                .el-button--primary {
                                    background-color: #157efb;
                                    border-color: #157efb;
                                    -webkit-border-radius: 10px;
                                    -moz-border-radius: 10px;
                                    border-radius: 10px;

                                    &:hover {
                                        background: #59a2f9;
                                        border-color: #59a2f9;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .containerLeftBottom {
                background: #fff;
                padding: 30px;
                box-sizing: border-box;
                margin-top: 10px;

                .bottomMessage {
                    font-size: 15px;
                    color: #666;
                }

                /deep/ .el-tabs__content {
                    padding-bottom: 20px;
                }
            }

            .relatedRecommendation {
                box-sizing: border-box;
                background: #fff;
                padding: 15px 0;

                .recommendationTop {
                    margin: 0 auto;
                    background: #efefef;
                    width: 100px;
                    height: 100px;

                    img {
                        width: 100px;
                        height: 100px;
                    }
                }

                .recommendationTopMess {
                    text-align: center;

                    h4 {
                        margin: 10px 0;
                    }

                    p {
                        font-size: 14px;
                        color: #777;
                        margin-bottom: 10px;
                    }
                }

                .printTitle {
                    padding: 15px;
                    text-align: left;
                    box-sizing: border-box;
                    border-bottom: 1px solid #eee;
                    color: #157efb;
                    margin: 0;
                    font-size: 16px;
                    font-weight: 600;
                    justify-content: space-between;
                    align-items: flex-end;
                    padding-top: 0;

                    p {
                        font-size: 14px;
                        font-weight: normal;
                        color: #777;

                        i {
                            font-weight: bold;
                            color: #000;
                        }
                    }
                }

                ul {
                    li {
                        padding-top: 10px;
                        border-bottom: 1px dashed #eee;
                        text-align: center;
                        margin-bottom: 0;
                    }
                }

                .hotRecommendation {
                    padding: 10px;
                    border-bottom: 1px solid #efefef;

                    .newRightBox {
                        .newRightBoximg {
                            width: 120px;
                            height: 90px;
                            background: #efefef;
                            cursor: pointer;
                            flex-shrink: 0;

                            img {
                                width: 120px;
                                height: 90px;
                                // height: 60px;
                            }
                        }

                        .newRightBoxMess {
                            margin-left: 15px;
                            font-size: 14px;

                            h4 {
                                cursor: pointer;
                                width: 105px;
                                font-size: 12px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .h4 {
                                position: relative;

                                div {
                                    display: none;
                                    position: absolute;
                                    // top: -20px;
                                    // width: 300px;
                                    padding: 10px;
                                    background-color: white;
                                    left: -10px;
                                    width: 100px;
                                }
                            }

                            h4:hover {
                                color: #157efb;

                            }

                            .h4:hover div {
                                display: block;
                            }

                            p {
                                font-size: 12px;
                            }

                            p:nth-of-type(1) {
                                color: #666;
                                margin: 10px 0;
                            }

                            p:nth-of-type(2) {
                                color: #555;
                            }
                        }
                    }

                    .newRight {
                        color: #999;
                        margin-top: 15px;
                        font-size: 12px;

                        .newRightColor2 {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }

    .printTitle {
        font-size: 28px;
        font-weight: normal;
        color: #157efb;
        margin-top: 60px;
        margin-bottom: 30px;
        border-bottom: 1px solid #e3e3e3;
        padding-bottom: 10px;

        span.tit {
            padding-bottom: 10px;
            border-bottom: 1px solid #157efb;
        }

        span.more {
            font-size: 16px;
            float: right;
            margin-top: 10px;
        }

        .more i {
            color: #505050 !important;
        }
    }

    .content {
        /deep/ .el-col-4 {
            width: 20%;
        }
    }

    .box-card {
        border: 1px solid #e3e3e3;
        margin-bottom: 30px;
        font-size: 12px;

        h2 {
            font-size: 16px;
            margin-bottom: 5px;
        }

        .sDetail {
            font-size: 14px;
            margin: 15px auto;
            text-align: left;
        }

        .sPrice {
            font-size: 16px;
            color: #da251d;
            margin-bottom: 15px;

            span {
                font-size: 12px;
            }
        }

        .image {
            width: 64px;
            height: 64px;
            margin-top: 15px;
        }
    }

    .mpFooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ebeef5;
        margin: 0 -21px -15px;
        padding: 10px 20px;

        a {
            color: #505050;
        }
    }

    .hotSellServ {
        display: flex;
        align-items: center;

        p {
            /*text-align: center;*/
            font-size: 14px;
            color: #585858;
        }

        .topServBoxInfo h3 {
            font-size: 16px;
            margin-bottom: 6px;
            font-weight: normal;
        }
    }

    .simSoft li {
        margin: 0 0 30px 0;
    }

    .bottomTxt {
        margin-top: 15px;
        font-size: 13px;
        text-align: left;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both;
    }

    .evaluationDetails {
        .blue {
            color: #1181ff;
        }

        .right_sortbox {
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            margin-bottom: 15px;
            margin-top: 20px;

            p {
                cursor: pointer;
                margin-right: 40px;
                padding: 0 10px;
            }

            .p_active {
                color: #1181ff;
                background: #f3f8ff;
                border-radius: 8px;
            }
        }

        .right_sortbox2 {
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            margin-bottom: 15px;

            p {
                cursor: pointer;
                margin-right: 40px;
                padding: 0 10px;
                background: #f5f5f5;
                border-radius: 10px;
            }
        }

        .comList {
            border: 1px solid #efefef;
            border-radius: 10px;
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            -moz-box-sizing: border-box; /* Firefox */
            -webkit-box-sizing: border-box; /* Safari */
            margin-top: 15px;
            background: #fff;
            justify-content: space-between;
            align-items: center;

            .comList_img {
                width: 66px;
                height: 66px;
                background: #efefef;
                border-radius: 50%;
                margin-right: 15px;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }

            .comList_con {
                color: #777;
                margin-right: 10px;
                flex: 1;

                .con_title {
                    font-size: 16px;
                    margin-bottom: 5px;
                }

                .con_mess {
                    font-size: 14px;
                }

                span {
                    color: rgb(194, 194, 194);
                    font-size: 12px;
                }
            }

            .comList_star {
                flex-shrink: 0;

                .comList_star_A {
                    align-content: center;
                    margin-bottom: 3px;

                    span {
                        color: rgb(194, 194, 194);
                        font-size: 13px;
                        margin-right: 5px;
                        line-height: 22px;
                    }
                }
            }
        }
    }

    .additional_evaluation {
        font-size: 14px;
        color: #AF874D;
        width: 80%;
        margin-bottom: 20px;
        line-height: 24px;
        background: #efefef7a;
        border-radius: 10px;
        padding: 20px;
    }

    .modelDeta_centerMess {
        padding: 15px 0;
        color: #888;
		text-align: center;
    }

    .shelves {
        text-align: center;
        img {
            width: 406px;
        }
        .shelves_name {
            margin-top: 30px;
            font-size: 18px;
            color: rgb(187, 187, 187);
        }
        .shelves_time {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #666;
            margin-top: 70px;
            span:nth-of-type(1) {
                margin-right: 5px;
                color: #157efb;
            }
        }
        .shelves_click {
            margin-top: 10px;
            margin-bottom: 80px;
            font-size: 14px;
            color: #157efb;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/print/printServiceDetails.vue